import { ConversationSources } from "../collaboration/conversations/context/types";
import DbtDocsCollaborationProvider from "../collaboration/DbtDocsCollaborationProvider";
import DbtDocsDetails from "./DbtDocsDetails";

export interface Props {
  shareId: number;
  userId?: number;
  conversationGroupId?: number;
  source: ConversationSources;
}

const DbtDocs = ({ shareId, userId, conversationGroupId, source }: Props) => {
  return (
    <div className="altimate-component">
      <DbtDocsCollaborationProvider
        shareId={shareId}
        userId={userId}
        conversationGroupId={conversationGroupId}
        source={source}
      >
        <DbtDocsDetails />
      </DbtDocsCollaborationProvider>
    </div>
  );
};

export default DbtDocs;
